import { DashboardResponse, VersionListResponse, VersionResponse, VersionCreatePayload, VersionUpdatePayload } from '../types';

const getAuthHeaders = (): HeadersInit => ({
  'Authorization': `Bearer ${localStorage.getItem('access_token') || sessionStorage.getItem('access_token')}`,
});

const jsonHeaders = (): HeadersInit => ({
  ...getAuthHeaders(),
  'Content-Type': 'application/json',
});

export async function fetchDashboard(): Promise<DashboardResponse> {
  const response = await fetch('/api/admin/upgrades/dashboard', {
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch upgrade dashboard: ${response.statusText}`);
  }
  return response.json();
}

export async function fetchVersions(): Promise<VersionListResponse> {
  const response = await fetch('/api/admin/upgrades/versions', {
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch versions: ${response.statusText}`);
  }
  return response.json();
}

export async function fetchVersion(version: string): Promise<VersionResponse> {
  const response = await fetch(`/api/admin/upgrades/versions/${encodeURIComponent(version)}`, {
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch version ${version}: ${response.statusText}`);
  }
  return response.json();
}

export async function createVersion(payload: VersionCreatePayload): Promise<VersionResponse> {
  const response = await fetch('/api/admin/upgrades/versions', {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const body = await response.text();
    throw new Error(body || `Failed to create version: ${response.statusText}`);
  }
  return response.json();
}

export async function updateVersion(version: string, payload: VersionUpdatePayload): Promise<VersionResponse> {
  const response = await fetch(`/api/admin/upgrades/versions/${encodeURIComponent(version)}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const body = await response.text();
    throw new Error(body || `Failed to update version ${version}: ${response.statusText}`);
  }
  return response.json();
}
